export enum ROUTES_DICTIONARY_PAGE_TAB_KEYS {
  ALL = "ALL",
  EXPIRED = "EXPIRED",
  MARKED_FOR_DELETION = "MARKED_FOR_DELETION",
}
